import React from 'react'
import styled from 'react-emotion'
import { crop } from '../../../style'

const { sideSize, cornerSize, thickness, fill, stroke } = crop.handle

export const CropHandle = styled(({ direction, className }) => {
  return (
    <svg
      className={className}
      data-action={'crop-frame-' + direction}
      width={direction.length === 1 ? sideSize : cornerSize}
      height={cornerSize}
      xmlns="http://www.w3.org/2000/svg"
    >
      {direction.length === 1 ? (
        <rect
          x="0.5"
          y="0.5"
          width={sideSize - 1}
          height={thickness}
          fill={fill}
          stroke={stroke}
        />
      ) : (
        <path
          d={`M${cornerSize - 0.5}.5H.5v${thickness}h${cornerSize -
            1 -
            thickness}v${cornerSize - 1 - thickness}h${thickness}V.5z`}
          stroke={stroke}
          fill={fill}
        />
      )}
    </svg>
  )
})(({ direction }) => {
  const style = {
    label: 'CropHandle',
    position: 'absolute'
  }
  switch (direction) {
    case 'n':
      style.top = 0
      style.left = `calc(50% - ${crop.handle.sideSize / 2}px)`
      style.cursor = 'ns-resize'
      break
    case 's':
      style.bottom = 0
      style.left = `calc(50% - ${crop.handle.sideSize / 2}px)`
      style.transform = 'scaleY(-1)'
      style.cursor = 'ns-resize'
      break
    case 'e':
      style.right = 0
      style.top = `calc(50% - ${crop.handle.sideSize / 2}px)`
      style.transformOrigin = '50% 100%;'
      style.transform = 'rotate(90deg)'
      style.cursor = 'ew-resize'
      break
    case 'w':
      style.left = 0
      style.top = `calc(50% - ${crop.handle.sideSize / 2}px)`
      style.transformOrigin = '50% 100%;'
      style.transform = 'rotate(270deg)'
      style.cursor = 'ew-resize'
      break
    case 'ne':
      style.top = 0
      style.right = 0
      style.cursor = 'nesw-resize'
      break
    case 'nw':
      style.top = 0
      style.left = 0
      style.transform = 'scaleX(-1)'
      style.cursor = 'nwse-resize'
      break
    case 'se':
      style.bottom = 0
      style.right = 0
      style.transform = 'scaleY(-1)'
      style.cursor = 'nwse-resize'
      break
    case 'sw':
      style.bottom = 0
      style.left = 0
      style.transform = 'scale(-1)'
      style.cursor = 'nesw-resize'
      break
    default:
      break
  }
  return style
})

export default CropHandle